import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrainsRoutingModule } from './trains-routing.module';
import { TrainListComponent } from './components/train-list/train-list.component';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { TRAINS_STATES } from  './trains.states';
import { TrainEditComponent } from './components/train-edit/train-edit.component';
import { GetTrainPipe } from './pipes/get-train.pipe';
import { DisplayTrainTypeNamePipe } from './pipes/display-train-type-name.pipe';
import { FilterTrainPipe } from './pipes/filter-train.pipe';


@NgModule({
  declarations: [TrainListComponent, TrainEditComponent, GetTrainPipe, DisplayTrainTypeNamePipe, FilterTrainPipe],
  imports: [
    SharedModule,
    UIRouterModule.forChild({ states: [...TRAINS_STATES]  }),
    TrainsRoutingModule
  ],
  exports: [
    GetTrainPipe,
    DisplayTrainTypeNamePipe,
    FilterTrainPipe
  ],
  providers: [DisplayTrainTypeNamePipe]
})
export class TrainsModule { }
